/**
 * -----------------------------------------------------------------------------
 * It renders the unchecked checkbox icon in dark gray color.
 */
export function UncheckedCheckboxIcon() {
  return (
    <svg
      fill="none"
      style={{ width: 24 }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          className="stroke-stone-800"
          d="M19.5 3.75h-15a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path className="fill-stone-50" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
